import React from 'react';
import { ChevronRight, ChevronLeft, Store } from 'lucide-react';

const DateSummary = ({ month, data, onDateClick, onBack }) => {
  if (!data || data.length === 0) {
    return (
      <div className="summary-empty">
        <p>No expenses recorded for {month.month_name} {month.year}.</p>
        <button className="back-btn" onClick={onBack}>
          <ChevronLeft size={16} /> Back to months
        </button>
      </div>
    );
  }

  return (
    <div className="date-summary">
      <div className="summary-nav">
        <button className="back-btn" onClick={onBack}>
          <ChevronLeft size={16} /> All Months
        </button>
        <div className="summary-nav-title">
          <h2>{month.month_name} {month.year}</h2>
          <p className="summary-nav-sub">
            Total: <strong>${month.total.toFixed(2)}</strong> across {month.visit_count} visits
          </p>
        </div>
      </div>

      <div className="date-list">
        {data.map((day) => (
          <button key={day.date}
            className="date-card"
            onClick={() => onDateClick(day)}>
            <div className="date-card-left">
              <div className="date-circle">
                <span className="date-day">
                  {new Date(day.date + 'T12:00:00').getDate()}
                </span>
                <span className="date-weekday">
                  {new Date(day.date + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'short' })}
                </span>
              </div>
              <div className="date-info">
                <p className="date-stores">
                  <Store size={12} />
                  {day.stores.slice(0, 2).join(', ')}
                  {day.stores.length > 2 && ` +${day.stores.length - 2} more`}
                </p>
                <p className="date-items">{day.item_count} items purchased</p>
              </div>
            </div>
            <div className="date-card-right">
              <span className="date-total">${day.total.toFixed(2)}</span>
              <ChevronRight size={16} color="#555" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DateSummary;
